import React from "react";
import { useDroppable } from "@dnd-kit/core";
import type { FieldDef } from "./ImportColumnMapper";

interface ColumnDropZoneProps {
    id: string;
    header: string;
    mappedFields?: FieldDef[];
    onRemoveField: (fieldKey: string) => void;
    hasSelectedField?: boolean;
    onTapPlace?: () => void;
}

function ColumnDropZone({ id, header, mappedFields = [], onRemoveField, hasSelectedField, onTapPlace }: ColumnDropZoneProps) {
    const { isOver, setNodeRef } = useDroppable({ id });
    const showTapHint = hasSelectedField && !isOver;

    return (
        <div
            ref={setNodeRef}
            onClick={() => { if (hasSelectedField) onTapPlace?.(); }}
            role="region"
            aria-label={`Drop zone for ${header} column`}
            style={{ minHeight: 60, padding: 8, cursor: hasSelectedField ? "pointer" : undefined }}
        >
            <div className="text-muted font-xs mb-1 text-truncate" title={header}>
                {header}
            </div>
            {mappedFields.length > 0 ? (
                <div className="d-flex flex-wrap gap-1">
                    {mappedFields.map((field, idx) => (
                        <div
                            key={field.key}
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 3,
                                padding: "2px 8px",
                                borderRadius: 16,
                                backgroundColor: field.required ? "#ede9fe" : "#f3f4f6",
                                color: field.required ? "#4f46e5" : "#374151",
                                fontSize: "0.65rem",
                                fontWeight: 600,
                            }}
                        >
                            <span style={{ color: "#9ca3af", fontSize: "0.55rem" }}>{idx + 1}</span>
                            {field.label}
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onRemoveField(field.key);
                                }}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                    padding: 0,
                                    lineHeight: 1,
                                    fontSize: "0.75rem",
                                    color: "#9ca3af",
                                }}
                            >
                                &times;
                            </button>
                        </div>
                    ))}
                </div>
            ) : (
                <div
                    style={{
                        padding: "4px 8px",
                        borderRadius: 6,
                        border: `1px dashed ${isOver ? "#4f46e5" : showTapHint ? "#818cf8" : "#d1d5db"}`,
                        backgroundColor: isOver ? "#f5f3ff" : showTapHint ? "#eef2ff" : "transparent",
                        fontSize: "0.65rem",
                        color: isOver || showTapHint ? "#4f46e5" : "#9ca3af",
                        textAlign: "center",
                        transition: "all 0.15s",
                    }}
                >
                    {showTapHint ? "Tap to place" : "Drop field"}
                </div>
            )}
        </div>
    );
}

export default ColumnDropZone;
